import { render, staticRenderFns } from "./ModalCluedo.vue?vue&type=template&id=7fc17e4a&"
import script from "./ModalCluedo.vue?vue&type=script&lang=js&"
export * from "./ModalCluedo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports